/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useRef } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  Spinner,
  Button,
  Label,
  Tooltip,
  Badge,
  UncontrolledTooltip,
} from "reactstrap";

import Select from "react-select";
import CreatableSelect from "react-select/creatable";

import TextareaAutosize from "react-textarea-autosize";

import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";

import mime from "mime";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";

import schema from "./ScriptsValidation.js";

import {
  getScript,
  createScript,
  editScript,
  resetScript,
  resetScripts,
  resetError,
} from "../../store/script/actions";

const Script = ({ t }) => {
  let { idScript } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const { register, handleSubmit, setValue, errors } = useForm({
    resolver: yupResolver(schema),
  });

  const {
    dataScriptGetSet,
    dataScriptEditCreate,
    loadingScript,
    loadingScriptEditCreate,
    successScript,
    errorScript,
  } = useSelector((state) => state.Script);

  const [newFields, setNewFields] = useState({});
  const [enableSubmit, setEnableSubmit] = useState(false);

  const [scriptValues, setScriptValues] = useState({
    title: "",
    titleBk: "",

    skills: [],
    skillsBk: [],

    global: false,
    globalBk: false,

    text: "",
    textBk: "",

    categories: [],
    categoriesBk: [],

    activated: true,
    activatedBk: true,

    files: "",
    filesBk: "",
  });

  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [tooltipObj, setTooltipObj] = useState(null);

  //FILE CONSTANTS
  const [fileObj, setFileObj] = useState(null);
  const [fileMsgError, setFileMsgError] = useState(null);
  const [activeThumb, setActiveThumb] = useState(false);
  const [infoFile, setInfoFile] = useState({ name: "", type: "" });
  const [fileInputExist, setFileInputExist] = useState(false);
  const fileInputRef = useRef(null);

  const supportedFiles = {
    file: {
      ext: ["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx"],
      maxSize: 10000,
      metric: "KB",
    },
    image: {
      ext: ["png", "jpeg", "jpg"],
      maxSize: 10000,
      metric: "KB",
    },
    video: {
      ext: ["mp4", "avi", "mov", "wmv", "webm", "ogg"],
      maxSize: 10000,
      metric: "KB",
    },
    audio: {
      ext: ["mp3", "aac", "ogg", "mpga", "wav"],
      maxSize: 10000,
      metric: "KB",
    },
  };

  const showToast = useCallback(
    (type, message) => {
      toastr[type](message);
    },
    [successScript]
  );
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () =>
      successScript &&
      dispatch(resetScript()) &&
      dispatch(resetScripts()) &&
      history.push("/scripts"),
  };

  const handleCreateEditScript = () => {
    if (idScript) {
      dispatch(editScript(idScript, newFields));
    } else {
      dispatch(createScript(newFields));
    }
  };

  const newScriptSubmit = (newScriptValues) => {
    handleCreateEditScript();
  };

  const arrayEquals = (a, b) => {
    return (
      Array.isArray(a) &&
      Array.isArray(b) &&
      a.length === b.length &&
      a.every((val, index) => val === b[index])
    );
  };

  const checkTitle = (values, valuesBk) => {
    if (values === valuesBk) {
      delete newFields.title;
      checkSubmit();
    } else {
      setNewFields({
        ...newFields,
        title: values,
      });
    }
  };

  const checkSkills = (values, valuesBk) => {
    if (values !== null) {
      let aux = [];
      let aux1 = values.map((e) => e.value);
      let aux2 =
        valuesBk !== undefined && valuesBk.length > 0
          ? valuesBk.map((e) => e.value)
          : [];

      if (arrayEquals(aux1, aux2)) {
        delete newFields.skills;
        checkSubmit();
      } else {
        values.map((item) => aux.push(item.value));
        setNewFields({
          ...newFields,
          skills: aux,
          global: false,
        });
      }
    } else {
      let aux1 = [];
      let aux2 = valuesBk !== undefined ? valuesBk.map((e) => e.id) : [];

      if (arrayEquals(aux1, aux2)) {
        delete newFields.skills;
        checkSubmit();
      } else {
        setNewFields({
          ...newFields,
          skills: [],
          global: false,
        });
      }
    }
  };

  const checkCategories = (values, valuesBk) => {
    if (values !== null) {
      let aux = [];
      let aux1 = values.map((e) => e.value);
      let aux2 =
        valuesBk !== undefined && valuesBk.length > 0
          ? valuesBk.map((e) => e.value)
          : [];

      if (arrayEquals(aux1, aux2)) {
        delete newFields.categories;
        checkSubmit();
      } else {
        values.map((item) => aux.push(item.value));
        setNewFields({
          ...newFields,
          categories: aux,
        });
      }
    } else {
      let aux1 = [];
      let aux2 = valuesBk !== undefined ? valuesBk.map((e) => e.id) : [];

      if (arrayEquals(aux1, aux2)) {
        delete newFields.categories;
        checkSubmit();
      } else {
        setNewFields({
          ...newFields,
          categories: [],
        });
      }
    }
  };

  const checkGlobal = (values, valuesBk) => {
    if (values === valuesBk) {
      delete newFields.global;
      checkSubmit();
    } else {
      setNewFields({
        ...newFields,
        skills: [],
        global: values,
      });
    }
  };

  const checkText = (values, valuesBk) => {
    if (values === valuesBk) {
      delete newFields.text;
      checkSubmit();
    } else {
      setNewFields({
        ...newFields,
        text: values,
      });
    }
  };

  const checkActivated = (values, valuesBk) => {
    if (values === valuesBk) {
      delete newFields.activated;
      checkSubmit();
    } else {
      setNewFields({
        ...newFields,
        activated: values,
      });
    }
  };

  const checkFile = (values, valuesBk) => {
    if (JSON.stringify(values) === JSON.stringify(valuesBk)) {
      delete newFields.files;
      checkSubmit();
    } else {
      setNewFields({
        ...newFields,
        files: values,
      });
    }
  };

  const optionsSkills = () => {
    let skills = [];

    if (dataScriptGetSet?.data?.form?.skill?.length > 0) {
      dataScriptGetSet.data.form.skill.map((skill) =>
        skills.push({
          key: skill.id,
          value: skill.id,
          label: skill.name,
        })
      );
    } else {
      if (loadingScript) {
        skills.push({
          value: "loading",
          label: t("Loading..."),
          isDisabled: true,
        });
      } else {
        skills.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }
    return skills;
  };

  const optionsCategories = () => {
    let categories = [];
    if (dataScriptGetSet?.data?.form?.categories?.length > 0) {
      dataScriptGetSet.data.form.categories.map((category, key) =>
        categories.push({
          key: category.categories + key,
          value: category.categories,
          label: category.categories,
        })
      );
    } else {
      if (loadingScript) {
        categories.push({
          value: "loading",
          label: t("Loading..."),
          isDisabled: true,
        });
      } else {
        categories.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }
    return categories;
  };

  const checkSubmit = () => {
    if (Object.keys(newFields).length > 0) setEnableSubmit(true);
    else setEnableSubmit(false);
  };

  const getInfoFile = (url) => {
    const matchUrl = url.match(new RegExp("name." + "(.*)" + "sv"));
    const name = matchUrl[1].replace("?", "");
    const ext = name.split(".").pop();
    if (supportedFiles.file.ext.includes(ext)) {
      return { name, type: "file" };
    } else if (supportedFiles.image.ext.includes(ext)) {
      return { name, type: "image" };
    } else if (supportedFiles.video.ext.includes(ext)) {
      return { name, type: "video" };
    } else {
      return { name, type: "audio" };
    }
  };

  const resetFile = () => {
    if (fileInputRef?.current) {
      fileInputRef.current.value = "";
      setFileObj(null);
      checkFile(null, scriptValues.filesBk);
      setScriptValues({
        ...scriptValues,
        files: {},
      });
      setFileMsgError(null);
      setFileInputExist(false);
      delete newFields.files;
    }
  };

  const deleteFile = () => {
    if (activeThumb) {
      setFileObj(null);
      checkFile(null, scriptValues.filesBk);
      setScriptValues({
        ...scriptValues,
        files: {},
      });
      setFileMsgError(null);
      setFileInputExist(false);
      delete newFields.files;
    }
    setActiveThumb(false);
  };

  const fileToBase64 = async (file) => {
    const result_base64 = await new Promise((resolve) => {
      const fileReader = new FileReader();
      fileReader.onload = () => resolve(fileReader.result);
      fileReader.readAsDataURL(file);
    });
    return result_base64;
  };

  const handleSendFile = async (file) => {
    if (file) {
      const fileBase64 = await fileToBase64(file);
      const fileName = file?.name;
      const dataSplit = fileBase64.split(",");
      const fileMimeType = file?.type;
      const fileType =
        fileMimeType.split("/")[0] === "application"
          ? "file"
          : fileMimeType.split("/")[0];
      const fileExts = mime?.getExtension(fileMimeType);
      const fileSize = file?.size;

      setFileObj({
        name: fileName,
        mimeType: fileMimeType,
        base64: dataSplit[1],
        formData: file,
        type: fileType,
        exts: fileExts,
        size: fileSize,
      });
      setFileInputExist(true);
    }
  };

  /*****FILE VALIDATE*****/
  const fileValidate = (file) => {
    const type = file?.type;
    const extensions = file?.exts;
    const size = file?.size;

    try {
      //Validate FileType
      if (
        type === "image" ||
        type === "file" ||
        type === "audio" ||
        type === "video"
      ) {
        //Validate FileExt
        if (
          supportedFiles[type]?.ext?.some(
            (supportedItem) => extensions === supportedItem
          )
        ) {
          const maxSizeToBytes =
            supportedFiles[type]?.metric === "KB"
              ? supportedFiles[type]?.maxSize * 1024
              : supportedFiles[type]?.metric === "MB"
              ? supportedFiles[type]?.maxSize * 1024 * 1024
              : supportedFiles[type]?.metric === "GB"
              ? supportedFiles[type]?.maxSize * 1024 * 1024 * 1024
              : supportedFiles[type]?.metric === "TB"
              ? supportedFiles[type]?.maxSize * 1024 * 1024 * 1024 * 1024
              : supportedFiles[type]?.maxSize;
          //Validate FileSize
          if (size < maxSizeToBytes) {
            return { error: false, message: null };
          } else {
            return {
              error: true,
              message: `${t("Add files smaller than")} ${
                supportedFiles[type]?.maxSize
              } ${supportedFiles[type]?.metric}`,
            };
          }
        } else {
          const msgExt = ` ${t("Only")} ${t(type)} ${t(
            "with extension"
          )}: ${supportedFiles[type]?.ext?.join(", ")}`;
          return {
            error: true,
            message: `
            ${t("File extension not valid")}.
            ${supportedFiles[type]?.ext ? msgExt : ""}`,
          };
        }
      } else {
        return {
          error: true,
          message: t("File not valid"),
        };
      }
    } catch (error) {
      return {
        error: true,
        message: error,
      };
    }
  };

  useEffect(() => {
    const objValidate = fileValidate(fileObj);
    const isValidate = !objValidate?.error;
    if (isValidate) {
      const fileResult = {
        data: fileObj?.base64,
        mimeType: fileObj?.mimeType,
        fileName: fileObj?.name,
      };
      setScriptValues({
        ...scriptValues,
        files: fileResult,
      });
      setValue("scriptFiles", fileResult);
      checkFile(fileResult, scriptValues?.filesBk);
      setFileInputExist(true);
    }
    setFileMsgError(objValidate?.message);
  }, [fileObj]);

  useEffect(() => {
    if (fileMsgError?.length > 0 && fileInputExist) {
      setEnableSubmit(false);
    }
  }, [fileMsgError, fileInputExist]);

  useEffect(() => {
    setTooltipOpen(true);
    setTimeout(() => {
      setTooltipOpen(false);
    }, 1500);
  }, [tooltipObj]);

  useEffect(() => {
    if (idScript) {
      dispatch(getScript(idScript, true));
    } else {
      dispatch(getScript(null, true));
    }
  }, []);

  useEffect(() => {
    if (
      idScript &&
      dataScriptGetSet &&
      dataScriptGetSet.data &&
      !loadingScript
    ) {
      setValue("scriptSkill", dataScriptGetSet.data.skills);
      setValue("scriptCategories", dataScriptGetSet.data.categories);
      setScriptValues({
        ...scriptValues,
        title: dataScriptGetSet.data.title,
        titleBk: dataScriptGetSet.data.title,

        skills:
          dataScriptGetSet?.data?.skills &&
          dataScriptGetSet.data.skills.length > 0
            ? dataScriptGetSet.data.skills.map((e) => ({
                key: e.id,
                value: e.id,
                label: e.name,
              }))
            : [],
        skillsBk:
          dataScriptGetSet?.data?.skills &&
          dataScriptGetSet.data.skills.length > 0
            ? dataScriptGetSet.data.skills.map((e) => ({
                key: e.id,
                value: e.id,
                label: e.name,
              }))
            : [],

        global: dataScriptGetSet.data.global ? true : false,
        globalBk: dataScriptGetSet.data.global ? true : false,

        text: dataScriptGetSet.data.text,
        textBk: dataScriptGetSet.data.text,

        categories:
          dataScriptGetSet?.data?.categories &&
          dataScriptGetSet.data.categories.length > 0
            ? dataScriptGetSet.data.categories.map((e, key) => ({
                key: e + key,
                value: e,
                label: e,
              }))
            : [],
        categoriesBk:
          dataScriptGetSet?.data?.categories &&
          dataScriptGetSet.data.categories.length > 0
            ? dataScriptGetSet.data.categories.map((e, key) => ({
                key: e + key,
                value: e,
                label: e,
              }))
            : [],
        activated: dataScriptGetSet.data.activated ? true : false,
        activatedBk: dataScriptGetSet.data.activated ? true : false,

        files: dataScriptGetSet?.data?.files,
        filesBk: dataScriptGetSet?.data?.files,
      });
    }

    if (dataScriptGetSet?.data?.files) {
      setActiveThumb(true);
      setInfoFile(getInfoFile(dataScriptGetSet?.data?.files));
    } else {
      setActiveThumb(false);
    }
  }, [dataScriptGetSet]);

  useEffect(() => {
    if (dataScriptEditCreate && dataScriptEditCreate.message) {
      showToast("success", t(dataScriptEditCreate.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successScript]);

  useEffect(() => {
    if (errorScript && typeof errorScript === "object") {
      errorScript.map((error) => showToast("error", t(error.value)));
      dispatch(resetError());
    } else {
      if (errorScript) {
        showToast("error", t(errorScript));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorScript]);

  useEffect(() => {
    checkSubmit();
  }, [newFields]);

  useEffect(() => {}, [scriptValues]);

  const setClassName = (errors, classname) => {
    return errors ? "av-invalid is-invalid " + classname : classname;
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/scripts"
            path={"/script"}
            title={t("Scripts")}
            breadcrumbItem={idScript ? t("Edit Script") : t("Create Script")}
          />
          <Row>
            <Col xs="12" className="customContent">
              <Card>
                <CardBody>
                  <form onSubmit={handleSubmit(newScriptSubmit)}>
                    <Row className="mb-3 justify-content-between">
                      <Col className="pr-2" lg="12">
                        <Row>
                          <Col md="12">
                            <FormGroup>
                              <Label id="script-name-label">
                                {t("Title") + " *"}
                              </Label>
                              <input
                                type="text"
                                name="scriptName"
                                ref={register}
                                className={setClassName(
                                  errors.scriptName,
                                  "form-control"
                                )}
                                placeholder={t("Enter script name")}
                                onChange={(e) => {
                                  setScriptValues({
                                    ...scriptValues,
                                    title: e.target.value,
                                  });
                                  checkTitle(
                                    e.target.value,
                                    scriptValues.titleBk
                                  );
                                }}
                                defaultValue={scriptValues.title}
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.scriptName?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup className="select2-container">
                              <div
                                className="d-flex justify-content-between w-100"
                                name="scriptType"
                              >
                                <Label id="scripts-skill">
                                  {t("Skills") + " *"}
                                </Label>
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    name="scriptGlobal"
                                    id="global"
                                    ref={register}
                                    checked={scriptValues.global ? true : false}
                                    readOnly
                                  />
                                  <label
                                    id="scripts-global"
                                    className="custom-control-label"
                                    onClick={() => {
                                      if (!scriptValues.global) {
                                        setScriptValues({
                                          ...scriptValues,
                                          global: !scriptValues.global,
                                          skills: null,
                                        });
                                        delete newFields.skills;
                                        setValue("scriptSkill", null);
                                      } else {
                                        setScriptValues({
                                          ...scriptValues,
                                          global: !scriptValues.global,
                                        });
                                      }
                                      checkGlobal(
                                        !scriptValues.global,
                                        scriptValues.globalBk
                                      );
                                    }}
                                  >
                                    {t("Enable Global")}
                                  </label>
                                </div>
                              </div>
                              <Select
                                id="scriptskill"
                                name="scriptSkill"
                                noOptionsMessage={() => t("No Options")}
                                ref={() => register({ name: "scriptSkill" })}
                                classNamePrefix="select2-selection"
                                className={setClassName(
                                  errors.scriptSkill,
                                  " select2-selection"
                                )}
                                placeholder={t("Choose") + "..."}
                                options={optionsSkills()}
                                onChange={(e) => {
                                  let value = e ? e : [];
                                  setValue("scriptSkill", value);
                                  if (scriptValues.global) {
                                    setScriptValues({
                                      ...scriptValues,
                                      skills: value,
                                      global: null,
                                    });
                                  } else {
                                    setScriptValues({
                                      ...scriptValues,
                                      skills: value,
                                    });
                                  }
                                  checkSkills(value, scriptValues.skillsBk);
                                }}
                                value={scriptValues.skills}
                                isMulti
                                isClearable
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.scriptSkill?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup className="select2-container">
                              <div
                                className="d-flex justify-content-between w-100"
                                name="scriptType"
                              >
                                <Label id="scripts-skill">
                                  {t("Categories") + " *"}
                                </Label>
                              </div>
                              <CreatableSelect
                                id="scriptCategories"
                                name="scriptCategories"
                                formatCreateLabel={(value) => (
                                  <span>
                                    {t("Create")} "{value}"
                                  </span>
                                )}
                                noOptionsMessage={() => t("No Options")}
                                ref={() =>
                                  register({ name: "scriptCategories" })
                                }
                                classNamePrefix="select2-selection"
                                className={setClassName(
                                  errors.scriptCategories,
                                  " select2-selection"
                                )}
                                placeholder={t("Choose") + "..."}
                                options={optionsCategories()}
                                onChange={(e) => {
                                  let value = e ? e : [];

                                  setValue("scriptCategories", value);
                                  setScriptValues({
                                    ...scriptValues,
                                    categories: value,
                                  });
                                  checkCategories(
                                    value,
                                    scriptValues.categoriesBk
                                  );
                                }}
                                value={scriptValues.categories}
                                isMulti
                                isClearable
                              />
                              <div className="invalid-feedback d-block">
                                {t(errors.scriptCategories?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup>
                              <Label id="script-name-label">
                                {t("Text") + " *"}
                              </Label>
                              <div className="textarea-container">
                                <TextareaAutosize
                                  type="textarea"
                                  name="scriptText"
                                  ref={register}
                                  className={setClassName(
                                    errors.scriptText,
                                    "form-control"
                                  )}
                                  placeholder={t("Enter script message text")}
                                  onChange={(e) => {
                                    setScriptValues({
                                      ...scriptValues,
                                      text: e.target.value,
                                    });
                                    checkText(
                                      e.target.value,
                                      scriptValues.textBk
                                    );
                                  }}
                                  defaultValue={scriptValues.text}
                                />
                                <div id="textCopy"></div>
                              </div>
                              <div className="invalid-feedback d-block">
                                {t(errors.scriptText?.message)}
                              </div>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <FormGroup>
                              <div className="d-flex justify-content-between">
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    name="scriptActivated"
                                    id="activated"
                                    ref={register}
                                    checked={
                                      scriptValues.activated ? true : false
                                    }
                                    readOnly
                                  />
                                  <label
                                    id="scripts-activated"
                                    className="custom-control-label"
                                    onClick={() => {
                                      setScriptValues({
                                        ...scriptValues,
                                        activated: !scriptValues.activated,
                                      });
                                      checkActivated(
                                        !scriptValues.activated,
                                        scriptValues.activatedBk
                                      );
                                    }}
                                  >
                                    {t("Activated")}
                                  </label>
                                </div>

                                {/* FILE */}
                                {activeThumb ? (
                                  <div className="d-flex align-self-center w-200 overflow-auto">
                                    <div>
                                      <div>
                                        {infoFile?.name || fileObj?.fileName}
                                      </div>

                                      <Button
                                        className="justify-content-center"
                                        color="info"
                                        onClick={(e) => {
                                          window.open(scriptValues?.files);
                                        }}
                                      >
                                        <i
                                          className={`bx ${
                                            infoFile?.type === "file"
                                              ? "bx-file-blank"
                                              : infoFile?.type === "image"
                                              ? "bx-image"
                                              : infoFile?.type === "video"
                                              ? "bx-movie"
                                              : infoFile?.type === "audio"
                                              ? "bx-music"
                                              : "bx-file-blank"
                                          } px-2  `}
                                        />
                                        {t("Preview")}
                                      </Button>

                                      <Button
                                        color="danger"
                                        onClick={() => {
                                          deleteFile();
                                        }}
                                      >
                                        <i
                                          color="white"
                                          className="mdi mdi-window-close pointer"
                                          id="deletetooltip"
                                        >
                                          <UncontrolledTooltip
                                            placement="left"
                                            target="deletetooltip"
                                          >
                                            {t("Delete")}
                                          </UncontrolledTooltip>
                                        </i>
                                      </Button>
                                    </div>
                                  </div>
                                ) : (
                                  <div
                                    className="d-flex"
                                    ref={() =>
                                      register({ name: "scriptFiles" })
                                    }
                                  >
                                    <input
                                      id="scriptFiles"
                                      ref={fileInputRef}
                                      type="file"
                                      onChange={(e) => {
                                        handleSendFile(e?.target?.files[0]);
                                      }}
                                      onClick={(e) => {
                                        resetFile();
                                      }}
                                    />
                                    {fileObj && (
                                      <div className="align-self-center">
                                        <i
                                          onClick={() => {
                                            resetFile();
                                          }}
                                          className="mdi mdi-window-close text-danger pointer"
                                          id="deletetooltip"
                                        >
                                          <UncontrolledTooltip
                                            placement="left"
                                            target="deletetooltip"
                                          >
                                            {t("Delete")}
                                          </UncontrolledTooltip>
                                        </i>
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                              {fileMsgError && fileInputExist && (
                                <div className="d-flex mt-1">
                                  <Badge
                                    color="danger"
                                    className="font-size-13 wrap-normal"
                                  >
                                    {fileMsgError}
                                  </Badge>
                                </div>
                              )}
                            </FormGroup>
                            <div className="invalid-feedback d-block">
                              {t(errors.scriptFiles?.data.message)}
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    {tooltipOpen && tooltipObj && (
                      <Tooltip
                        placement="auto"
                        isOpen={tooltipOpen}
                        target={tooltipObj?.target}
                      >
                        <div className="keywords-tooltip">
                          {tooltipObj?.message}
                        </div>
                      </Tooltip>
                    )}

                    <Button
                      type="submit"
                      color="primary"
                      className="mr-1 waves-effect waves-light"
                      style={{
                        minWidth: "100px",
                        cursor: enableSubmit ? "pointer" : "no-drop",
                      }}
                      disabled={!enableSubmit}
                    >
                      {loadingScriptEditCreate ? (
                        <Spinner
                          size="sm"
                          animation="border"
                          style={{
                            height: "19px",
                            width: "19px",
                          }}
                        />
                      ) : (
                        t("Confirm")
                      )}
                    </Button>
                    <Link to="/scripts">
                      <Button
                        type="button"
                        color="secondary"
                        className="waves-effect btn-dark"
                        onClick={() => dispatch(resetScript())}
                      >
                        {t("Cancel")}
                      </Button>
                    </Link>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Script);
